import ErrorList from 'components/ErrorList/ErrorList';

export default ErrorList;
